import React from 'react'
import axios from 'axios'

class Theatre extends React.Component {
	constructor(props){
		super(props)

		this.state = {
			items: [],
			banner: null
		}
	}

	componentDidMount(){
		this.fetchData()
	}

	fetchData(){
		axios.get('https://dhsetheatre-api.madebypeppernet.com/api-admin.php', {
			params: {
				filename: 'theatre'
			}
		}).then( response => {
			this.setState({
				items: response.data.items,
				banner: response.data.banner
			})
		})
	}

	render() {
		return (
			<section className="container">
				<h2>About Our Theatre</h2>
				{
					this.state.banner ?
						<img src={this.state.banner} alt="theatre banner" /> :
						null
				}
				{
					this.state.items.map( (item, index) => {
						return (
							<div key={index} className="dynamic">
								<h3>{decodeURIComponent(item.headline)}</h3>
								<p>{decodeURIComponent(item.content)}</p>
							</div>
						)
					})
				}
			</section>
		)
	}
}

export default Theatre



// WEBPACK FOOTER //
// ./src/pages/theatre.js